module.exports = __webpack_public_path__ + "img/escalator.a4c0c133.png";